import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

// Backend hata mesajı çevirileri. Kayıtlar content servisinde tutulur; yayınlandığında tms çevirileri
// CDN'e messages-{lang}.json olarak yükler ve kanallar hata cevabındaki messageKey ile bu metni gösterir.
const getDefaultSelectedMessageTranslation = () => {
  return {
    key: "",
    language: "tr",
    value: "",
  };
};

export default {
  state: () => ({
    selectedMessageTranslation: getDefaultSelectedMessageTranslation(),
    // Son yüklenen çeviri listesi; tanımlama ekranı eksik dil ve değişken uyarıları için kullanır.
    messageTranslations: [],
  }),
  mutations: {
    setSelectedMessageTranslation(state, messageTranslation) {
      Vue.set(state, "selectedMessageTranslation", messageTranslation);
    },
    setDefaultSelectedMessageTranslation(state) {
      Vue.set(state, "selectedMessageTranslation", getDefaultSelectedMessageTranslation());
    },
    setMessageTranslations(state, messageTranslations) {
      Vue.set(state, "messageTranslations", messageTranslations);
    },
  },
  actions: {
    // Hata cevabı (aynı anahtar ve dil için kayıt, desteklenmeyen dil) ekranda gösterilebilsin diye yutulmuyor.
    createMessageTranslation: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/message-translations/entity", request, {});
    },
    loadMessageTranslations: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/entity").then((response) => {
        context.commit("setMessageTranslations", response.data);
        return response.data;
      });
    },
    loadMessageTranslation: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/entity/" + request.id).then((response) => {
        context.commit("setSelectedMessageTranslation", response.data);
        return response.data;
      });
    },
    loadSelectedMessageTranslationHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteMessageTranslation: (context, messageTranslation) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/message-translations/entity/" + messageTranslation.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          messageTranslation.intents = intents;
          messageTranslation.intentId = response.data.id;
          return messageTranslation;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftMessageTranslation: (context, messageTranslation) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/message-translations/draft/" + messageTranslation.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishMessageTranslation: (context, messageTranslation) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/publish/" + messageTranslation.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectMessageTranslation: (context, messageTranslation) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/reject/" + messageTranslation.intentId).then((response) => {
        if (messageTranslation.intents[0].type === "DELETE_MESSAGE_TRANSLATION") {
          messageTranslation.intents = null;
          messageTranslation.intentId = 0;
        } else if (messageTranslation.intents[0].type === "CREATE_MESSAGE_TRANSLATION") {
          messageTranslation.intents[0].status = "DRAFT";
        } else if (messageTranslation.intents[0].type === "UPDATE_MESSAGE_TRANSLATION") {
          messageTranslation.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalMessageTranslation: (context, messageTranslation) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/sendToApproval/" + messageTranslation.intentId).then((response) => {
        if (messageTranslation.intents[0].type === "CREATE_MESSAGE_TRANSLATION") {
          messageTranslation.intents[0].status = "WAITING_APPROVAL";
        } else if (messageTranslation.intents[0].type === "UPDATE_MESSAGE_TRANSLATION") {
          messageTranslation.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallMessageTranslation: (context, messageTranslation) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/recall/" + messageTranslation.intentId).then((response) => {
        helper.recallOrRejectEntity(messageTranslation, "message_translation");
        return response.data;
      });
    },
    cancelMessageTranslation: (context, messageTranslation) => {
      return axios.get(context.getters.getMcServiceUrl + "/message-translations/cancel/" + messageTranslation.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedMessageTranslation: (state) => {
      return state.selectedMessageTranslation;
    },
    getMessageTranslations: (state) => {
      return state.messageTranslations;
    },
  },
};
